import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faCircleQuestion,
} from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";

import CopyButton from "../Message/CopyButton";
import * as types from "types";
import styles from "./MessageHistory.module.scss";

const COMPACTION_TOOLTIP =
  "Earlier messages were summarized to keep the conversation within the assistant's memory. The system message is always retained. Your original messages are still preserved above.";

interface CompactionSummaryProps {
  message: types.CompactionMessage;
}

export default function CompactionSummary({ message }: CompactionSummaryProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleSummary = () => setIsOpen((prev) => !prev);

  return (
    <div className={styles.compactionContainer}>
      <span className={styles.compactionRole}>System</span>
      <div className={styles.compactionMessage} data-open={isOpen}>
        <div className={styles.compactionIcon}>
          <FontAwesomeIcon icon={faCircleInfo} />
        </div>
        <div className={styles.compactionContent}>
          <button
            type="button"
            className={styles.compactionHeader}
            onClick={toggleSummary}
            aria-expanded={isOpen}
          >
            <span className={styles.compactionTitles}>
              <span className={styles.compactionTitle}>
                Conversation summary
                <Tippy content={COMPACTION_TOOLTIP} placement="top">
                  <span className={styles.compactionHelp}>
                    <FontAwesomeIcon icon={faCircleQuestion} />
                  </span>
                </Tippy>
              </span>
              <span className={styles.compactionSubtitle}>
                Summarized {message.covered_message_count} messages &middot;{" "}
                {isOpen ? "click to collapse" : "click to expand"}
              </span>
            </span>
            <span className={styles.compactionChevron}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
          </button>
          <div className={styles.compactionBodyWrap}>
            <div className={styles.compactionBodyInner}>
              <div className={styles.compactionCopy}>
                <CopyButton content={message.content} />
              </div>
              <div className={styles.compactionBody}>
                <p>{message.content}</p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.compactionSpacer} aria-hidden="true" />
      </div>
    </div>
  );
}
